import { render, staticRenderFns } from "./OrdersGrid.vue?vue&type=template&id=2ef1c84a&scoped=true&"
import script from "./OrdersGrid.vue?vue&type=script&lang=js&"
export * from "./OrdersGrid.vue?vue&type=script&lang=js&"
import style0 from "./OrdersGrid.vue?vue&type=style&index=0&id=2ef1c84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1c84a",
  null
  
)

export default component.exports